import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'

export default function DescriptionHead({ software }) {
  const { name, tags, countries, exchanges, logo } = software

  return (
    <Row style={{ width: '100%' }}>
      <Col span={24}>
        <Row>
          <Col md={24} xs={24}>
            <Row>
              <Col span={24}>
                <div
                  style={{
                    width: '100%',
                  }}
                >
                  <img
                    height="70px"
                    style={{ float: 'left', marginRight: '10px' }}
                    src={`${logo.data?.attributes.url}`}
                    alt={name}
                  />
                  <div style={{ float: 'left', padding: '10px 10px 10px 0px' }}>
                    <div
                      style={{
                        fontSize: '18px',
                        color: '#000000',
                      }}
                    >
                      {`${name} Review`}
                    </div>
                    <div
                      style={{
                        fontSize: '15px',
                      }}
                    >
                      <span style={{ color: '#000000' }}>Segments: </span>
                      <span>
                        {tags && tags.length > 0
                          ? tags.map((tag, i) =>
                              i === 0 ? `${tag}` : `/${tag}`
                            )
                          : 'No Segment Associated'}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row style={{ marginTop: '24px' }}>
          <Col md={18} xs={24} style={{ minHeight: '20px' }}>
            <span style={{ color: '#000000' }}>Countries: </span>
            {countries.data && countries.data.length > 0
              ? countries.data.map((countryObject, i) =>
                  i === 0
                    ? `${countryObject.attributes.name}`
                    : `, ${countryObject.attributes.name}`
                )
              : 'No Country Associated'}
          </Col>
          <Col md={6} xs={24} style={{ minHeight: '20px' }}>
            <Row>
              <Col md={24} xs={24}>
                <span style={{ color: '#000000' }}>Exchanges: </span>
                {exchanges.data && exchanges.data.length > 0
                  ? exchanges.data.map((exchangeObject, i) =>
                      i === 0
                        ? `${exchangeObject.attributes.name}`
                        : `, ${exchangeObject.attributes.name}`
                    )
                  : 'No Exchange Associated'}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

DescriptionHead.propTypes = {
  software: PropTypes.shape({
    name: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    logo: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
    countries: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
    exchanges: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
}
